export default {"src":"/_next/static/media/checkboxTick.2b8a8b1e.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};